import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-material',
  templateUrl: './mobile-material.component.html',
  styleUrls: ['./mobile-material.component.scss']
})
export class MobileMaterialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
